'use strict';

import { newModalFromSelector, newModalFromString } from '../components/modal';
import Plugins from '../util/plugins';
import FormHelpers from '../util/form';
import RegistrationHelper from '../account/registrationHelper';
import UnifiedRegistration from '../account/unifiedRegistration';

const toggleRememberPopover = function (fromLayer, state) {
    const location = fromLayer ? '.layer-login-modal ' : '.login-tabs ';
    if (state) {
        $(location + '.popover-remember-me').fadeIn('fast', function () {
            $(this).removeClass('hidden');
        });
    } else {
        $(location + '.popover-remember-me').fadeOut('fast', function () {
            $(this).addClass('hidden');
        });
    }
};

const checkRememberFlag = function (fromLayer) {
    var button = $('#rememberMe');
    if (fromLayer) {
        button = $('.layer-login-modal #rememberMeTwo');
    }

    if (!button.length || button.is(':checked')) {
        return true;
    }

    var rememberMeFlagState = button.data('rememberMe-check');
    if (!rememberMeFlagState) {
        button.data('rememberMe-check', true);
    }

    toggleRememberPopover(fromLayer, !rememberMeFlagState);

    return rememberMeFlagState;
};

class Customer {
    socialLoginHandler (fromLayer = false) {
        const _self = this;

        $('body').on('socialLogin:handler', function (e, data) {
            var containerID = data.loginResult && data.loginResult.containerID;
            var url = containerID ? $('#' + containerID).data('url') : null;
            if (!url) {
                url = $('.socialLoginContainer').data('url');
                if ($('#loginGigya').length) {
                    url = $('#loginGigya.socialLoginContainer').data('url');
                }
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data.loginResult.user,
                success: function (data) {
                    $.spinner().stop();
                    if (containerID && $('#' + containerID).closest('#unified-login-form').length) {
                        data.regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
                    }
                    if (!data.success) {
                        if (data.sfccRegisteredUser) {
                            // switch tab to "accedi"
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');

                            _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                            $('body').trigger('customer:social_email_already_used', {
                                'type': 'email',
                                'socialName': data.socialName,
                                'errorMsg': 'email_already_registered'
                            });
                        } else if (data.errorMessage) {
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');
                            if (data.socialLogin) {
                                $('body').trigger('customer:socialLogin', data);
                                _self.fireGenericAnalyticsErrorEvent('social_login', 'step1_login', 'generic_error');
                            }
                        }
                    } else {
                        localStorage.setItem('socialFirstStepMail', '');
                        if (data.socialLogin) {
                            $('body').trigger('customer:socialLogin', data);
                        }

                        var isUserLoyalty = data.response && data.response.customerFidelitySubscriptions && RegistrationHelper.isUserLoyaltyForThisBrand(data.response.customerFidelitySubscriptions);
                        if (data.socialLogin && !isUserLoyalty && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                            $('.js-unified-modal-loyalty-registration').first().trigger('click');
                            return;
                        }

                        if (!data.socialLogin) {
                            $('body').trigger('unifiedRegistration:socialRegistration', data);
                            return;
                        }

                        if (fromLayer && data.socialLogin) {
                            location.reload();
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        });
    };

    fireSpecificAnalyticsErrorEvent (mainType, subType, error, rememberMe, sessionExpired, regFlowPosition) {
        $('body').trigger('customer:' + mainType, {
            'type': subType,
            'regFlowPosition': regFlowPosition,
            'data': {
                'error': [error],
                'rememberMe': rememberMe,
                'sessionExpired': sessionExpired
            }
        });
    }

    fireGenericAnalyticsErrorEvent (type, step, errorMsg) {
        $('body').trigger('customer:account_error', {
            'type': type,
            'step': step,
            'errorMsg': errorMsg
        });
    }

    accountLoginForm (fromLayer = false, $myAccountEditButton) {
        const _self = this;
        $('form.login').ready(function () {
            if (window.location.href.indexOf('tab.reg') >= 0 || window.location.href.indexOf('tab%2ereg') >= 0) {
                $('#tab-login-cell, .js-link-access').removeClass('current');
                $('#tab-registration-cell, .js-link-register').addClass('current');
            }
        });

        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            if (!checkRememberFlag(fromLayer)) {
                return;
            } else {
                toggleRememberPopover(false);
            }
            var url = form.attr('action');
            if ($('.js-persistent-layer').length) {
                url += '&isPersistent=true';
            }
            $.spinner().start();

            var regFlowPosition;
            if (form.is('#unified-login-form')) {
                regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
            }

            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.socialCustomer) {
                            socialLoginOpenForgotPasswordModal(data.email);
                        } else {
                            FormHelpers.init(form, data);
                            $('form.login').trigger('login:error', data);
                            var loginErrorType = (data && data.alreadyRegistered) ? 'account_created_but_not_activated_yet' : 'wrong_email_or_wrong_password';
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', loginErrorType);
                            _self.fireSpecificAnalyticsErrorEvent('login', 'login', loginErrorType, data.rememberMe, false, regFlowPosition);
                        }
                    } else {
                        $('form.login').trigger('login:success', data);
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data,
                            'regFlowPosition': regFlowPosition
                        });

                        if (!RegistrationHelper.isUserLoyaltyForThisBrand(data.response.customerFidelitySubscriptions) && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                            $('.js-unified-modal-loyalty-registration').first().trigger('click');
                            return;
                        }
                        if (fromLayer && $myAccountEditButton && $myAccountEditButton.data('section')) {
                            $('[data-section="profile"]').removeClass('editProfilePersistent').addClass('js-edit-profile');
                            $('[data-section="email"]').removeClass('editProfilePersistent').addClass('js-edit-email');
                            $('[data-section="password"]').removeClass('editProfilePersistent').addClass('js-edit-password js-edit-password-persistent');
                            $('body').trigger('persistentLogin:standardCustomer');
                            let dataSection = $myAccountEditButton.data('section');
                            if (dataSection === 'profile') {
                                $('.js-edit-profile').trigger('click');
                            } else if (dataSection === 'email') {
                                $('.js-edit-email').trigger('click');
                            } else if (dataSection === 'password') {
                                $('.js-edit-password').trigger('click');
                            } else {
                                location.reload();
                            }
                        } else if (fromLayer) {
                            location.reload();
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'unknown_error');
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': {
                            'error': [ 'unknown_error' ]
                        },
                        'regFlowPosition': regFlowPosition
                    });

                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        $('.login-pwd .remember-me-container .rememberme-wrapper #rememberMeTwo').on('click', function () {
            $('body').trigger('customer:persistentTooltip');
        });

        function enableLoginAnalyticsObserver () {
            let targetLoginNode = $('form.login:visible')[0];
            if (targetLoginNode) {
                let config = { attributes: true, childList: true, subtree: true };
                let callback = function (mutationsList, observer) {
                    let inputSet = new Set();
                    let genericEventAlreadyFired = false;
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'INPUT' &&
                            mutation.attributeName === 'class' &&
                            mutation.target.classList.contains('is-invalid-input')) {
                            if (!inputSet.has(mutation.target.id)) {
                                let errorMsg = 'unknown_error';
                                if (mutation.target.id.includes('email')) {
                                    errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                                } else if (mutation.target.id.includes('password')) {
                                    errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                                } else {
                                    errorMsg = 'unknown_error';
                                }
                                let rememberMe = false;
                                let sessionExpired = false;
                                if ($('#rememberMe, .layer-login-modal #rememberMeTwo').length && $('#rememberMe,.layer-login-modal #rememberMeTwo').is(':checked')) {
                                    rememberMe = true;
                                }
                                if ($('.js-persistent-layer').length) {
                                    sessionExpired = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg, rememberMe, sessionExpired);
                                    genericEventAlreadyFired = true;
                                }

                                inputSet.add(mutation.target.id);
                            }
                        }
                    }
                    observer.disconnect();
                };

                let observer = new MutationObserver(callback);
                observer.observe(targetLoginNode, config);
            }
        }

        if ($('form.login').length > 0) {
            var submitButtonAnalytics = $('form.login').find('button[type=submit]:visible');
            if (submitButtonAnalytics.length === 0) {
                submitButtonAnalytics = $('form.login:first').find('button[type=submit]');
            }
            submitButtonAnalytics.on('click', function (e) {
                enableLoginAnalyticsObserver();
            });
        }

        function socialLoginOpenForgotPasswordModal (email) {
            $('body').trigger('socialLoginError:standardCustomer');
            const htmlContent = $('#requestPasswordResetModal').clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['resetPwdModal', 'layer-password-modal']);
            $(modal.modalBox).addClass('new-footer-form-style rightModalAttribute');
            Plugins.init();
            modal.open();
            _self.resetPasswordForm();
            $(modal.modalBox).find('.request-password-title').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-title').removeClass('hidden');
            if (Foundation.MediaQuery.atLeast('large')) {
                var socialTitle = $(modal.modalBox).find('.social-request-password-title.show-for-large').data('title');
            } else {
                var socialTitle = $(modal.modalBox).find('.social-request-password-title.hide-for-large').data('title-mobile');
            }
            $(modal.modalBox).find('.social-request-password-title').text(socialTitle);
            $(modal.modalBox).find('.request-password-body-description').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-body-description').removeClass('hidden');
            $(modal.modalBox).find('#reset-password-email').val(email);
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
            $(modal.modalBox).on('click', '.back-to-login', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
        }
    }

    resendActivationEmail () {
        $('body').on('click', '.resend-activation-email', function (e) {
            e.preventDefault();
            var url = $(e.currentTarget).attr('href');
            var email = $(e.currentTarget).data('email');
            const payload = {
                email: email
            };
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: payload,
                success: function (data) {
                    $.spinner().stop();
                    if (data.success) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        });
    };

    forgotPassword (modalToClose) {
        const self = this;
        $('#password-reset, .password-reset').on('click', function (e) {
            e.preventDefault();

            if (Foundation.MediaQuery.atLeast('medium')) {
                modalToClose.close();
                modalToClose.destroy();
            }

            const htmlContent = $($(this).data('target')).clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['resetPwdModal', 'layer-password-modal']);
            modal.open();
            const $modalBox = $(modal.modalBox);
            $modalBox.addClass('rightModalAttribute');
            $modalBox.find('.request-password-title').removeClass('hidden');
            $modalBox.find('.social-request-password-title').addClass('hidden');
            $modalBox.find('.request-password-body-description').removeClass('hidden');
            $modalBox.find('.social-request-password-body-description').addClass('hidden');
            $modalBox.on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
                if (modalToClose) {
                    modalToClose.close();
                    modalToClose.destroy();
                }
            });
            $modalBox.on('click', '.back-to-login', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });

            Plugins.init();
            self.resetPasswordForm();
        });
    };

    resetPasswordForm () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else {
                        form.closest('.modal-content').find('.request-password-title').text(data.receivedMsgHeading);
                        if (!Foundation.MediaQuery.atLeast('large') && data.receivedMsgHeadingMobile) {
                            $('.social-request-password-title').text(data.receivedMsgHeadingMobile);
                        } else {
                            $('.social-request-password-title').text(data.receivedMsgHeading);
                        }
                        $('.request-password-body', form).empty()
                            .append('<p class="font-normal">' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton', form).hide();
                            $('#loginButton', form)
                                .removeClass('hidden')
                                .attr('data-dismiss', 'modal')
                                .addClass('btn-close');
                        } else {
                            $('.send-email-btn', form).empty()
                                .html('<a href="' +
                                    data.returnUrl +
                                    '" class="button">' +
                                    data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    toggleVisiblePassword () {
        function _toggleVisibility (e) {
            const password = $(this).closest('.form-group').find('.pwd-input');
            const type = password.attr('type') === 'password' ? 'text' : 'password';
            password.attr('type', type);
            $(this).toggleClass('pwd-icon-visible');
            e.stopImmediatePropagation();
        }
        let evtType = 'click';
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            evtType = 'touchstart';
        }
        $('body').on(evtType, '.toggle-password', _toggleVisibility);
    }
}


export function calculateTopOffset() {
    let isHomePage = !!($('.page[data-action="Home-Show"]').length);
    let isCartPage = !!($('.page[data-action="Cart-Show"]').length);
    let totalHeight = 0;
    let totalTopStickyCart = 0;
    const headerNode = $('header.main-header').get(0);

    const paddingTopToAddInCart = parseInt($('.cell-right-info').css('padding-top'));

    headerNode && headerNode.style.setProperty('display', 'block', 'important');
    $(headerNode).children().each(function() {
        if($(this).outerHeight() > 0 && $(this).css('display') !== 'none' && $(this).is(':visible')) {
            
            if (isHomePage && $(this).hasClass('navigation--tezenis')) {
                return true;
            } else {
                // mobile search node occupies the whole screen - that has to be avoided in the calculation
                // only take the actual search form height
                if($(this).hasClass('mobile-search')) {
                    totalHeight += $(this).find('form[role=search]').outerHeight();
                } else {
                    totalHeight += $(this).outerHeight();
                }
            }
        }
    });
    headerNode && headerNode.style.removeProperty('display');
    $('body > .page').css('paddingTop', totalHeight);

    if (isCartPage && Foundation.MediaQuery.atLeast('large')) {
        totalTopStickyCart = totalHeight + paddingTopToAddInCart;
        $('.box-order-summary-container').css('top', totalTopStickyCart + 'px');
    }

    const $feedbackModal = $('.popover.popover-bottom');
    if ($feedbackModal.length === 0) return;

    let top = 0;

    const $sovraContainer = $('.top-header-placement');
    if ($sovraContainer.is(':visible')) {
        top += $sovraContainer.outerHeight() || 0;
    }

    const $countrySelect = $('.geoblockContainerBlur');
    if ($countrySelect.length && !$countrySelect.hasClass('hidden')) {
        top += $countrySelect.outerHeight() || 0;
    }

    $feedbackModal.css('top', top);
}
class Header {
    init () {
        this.accountDropdown();
        this.updateWishlistCounter();
        this.layerLogin();
        this.updatePage();
        this.customer = new Customer();
        UnifiedRegistration.init();
    }

    updatePage () {
        // Update page padding to compensate for fixed header
        const padding = $('header.main-header').outerHeight();
        if ($('.page .not-logged-wishlist').length > 0) {
            $('.page').addClass('wishlist-page-not-logged');
        }
        const outerPadding = $('#header-message-banner').outerHeight();
        $('.main-container').css('paddingTop', outerPadding);
        calculateTopOffset ();
    }


    accountDropdown () {
        const $accountDropdown = $('.main-header-login__dropdown');

        if ($accountDropdown.length) {
            $accountDropdown.on('mouseenter', (e) => {
                $accountDropdown.addClass('hover');
                $('.contactType, .contactSubType').blur();
            });

            $accountDropdown.on('mouseleave', (e) => {
                $accountDropdown.removeClass('hover');
            });

            $(document).on('keydown', (e) => {
                if (e.key === 'Escape' || e.key === 'Esc') {
                    if ($(document.activeElement).closest('.main-header-login__dropdown').length > 0) {
                        document.activeElement.blur();
                    }
                    $('.main-header-login__dropdown').removeClass('hover'); 
                }
            });
        }
    }

    updateWishlistCounter () {
        // Update wishlist counter
        $('body').on('wishlist:update', function (e, total) {
            const $counter = $('.main-header-wishlist .main-header-counter');
            $counter.text(total);

            if (total > 0) {
                $counter.show();
            } else {
                $counter.hide();
            }
        });
    }

    layerLogin () {
        const self = this;
        // Layer login must be disabled on the following pages
        const disabledPages = ['Login-Show', 'Order-Confirm', 'Newsletter-Confirm', 'Order-Details'];
        const currentPage = $('.page').data('action');
        const isLayerLoginDisabled = disabledPages.indexOf(currentPage) > -1;
        // Read by analytics (general_cta reg_flow_position)
        $('body').attr('data-layer-login-disabled', isLayerLoginDisabled ? 'true' : 'false');
        if ($('#login-popup').length) {
            $('.js-account-icon-mobile').addClass('js-layer-login');
        }

        $('body').on('click', '.js-layer-login, .main-header-login .not-logged-in a, .editProfilePersistent, .cartCustomerNotAuthenticated, .js-account-delete-persistent-button', function (e) {
            if (isLayerLoginDisabled) {
                return;
            }
            e.preventDefault();

            let isFromCart = $('.cart-page').length && $('.cartCustomerNotAuthenticated').data('url');
            const onClose = () => {
                UnifiedRegistration.unifiedCloseModalReloadOrLogout();
                UnifiedRegistration.resetWizard();
                if (isFromCart) {
                    $('body').trigger('cart:invalidatePersistentCustomerSession');
                }
            };
            var modal = newModalFromSelector('login-popup', false, ['layer-login-modal', 'cc-layer-login'], onClose);
            $(modal.modalBox).addClass('rightModalAttribute');
            $(modal.modalBox).find('.social-login-form-error').addClass('hidden');
            // Initialize new DOM element's form
            Plugins.init();
            RegistrationHelper.modalRegistrationInit();
            UnifiedRegistration.resetWizard();

            // Hide Remember Me Container for Modal in My Account
            if (currentPage === 'Account-Profile' || currentPage === 'Account-Show') {
                $('.remember-me-container').hide();
            }

            $('body').on('change', '#rememberMeTwo', function (e) {
                if ($('#rememberMeTwo').prop('checked')) {
                    $('.popover-remember-me').hide();
                    e.preventDefault();
                }
            });

            $('.close-button-info-popover').on('click', function (e) {
                $('.popover-remember-me').hide();
            });

            $('body').on('click', '.icon-info-black, .js-rememberme-tooltip-icon', function (e1) {
                if ($(e1.target).closest('.info-rememberme').length > 0 && !$(e1.target).hasClass('close-button-info-tooltip') && !$(e1.target).hasClass('js-close-rememberme-tooltip')) {
                    return;
                }
                e1.stopPropagation();
                $('.info-rememberme').removeClass('hide');
                if ($(this).closest('.js-unified-flow-container').length === 0) {
                    $('.tooltip-background').removeClass('hide');
                }
                $('body').on('click.closeTooltipEvent', function (e) {
                    if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).hasClass('js-close-rememberme-tooltip') || $(e.target).closest('.info-rememberme').length === 0) {
                        $('.info-rememberme').addClass('hide');
                        $('body').off('click.closeTooltipEvent');
                        $('.tooltip-background').addClass('hide');
                    }
                });
            });

            $('.checkbox-label').on('click', function (e) {
                return false;
            });

            if (Foundation.MediaQuery.atLeast('small')) {
                $('.icon-info-black, .js-rememberme-tooltip-icon').on('click', function (e) {
                    if ($(this).closest('.js-unified-flow-container').length === 0 && $(e.target).closest('.info-rememberme').length === 0) {
                        $('.tooltip-background').removeClass('hide');
                    }
                });
            }

            if ($(e.currentTarget).hasClass('editProfilePersistent')) {
                self.customer.accountLoginForm(true, $(e.currentTarget));
            } else {
                self.customer.accountLoginForm(true);
            }
            self.customer.forgotPassword(modal);
            self.customer.socialLoginHandler(true);
            self.customer.resendActivationEmail();
            self.customer.toggleVisiblePassword();

            modal.open();

            $('#login-form-email, #login-form-password').on('input', function () {
                if ($('#login-form-email').val() !== '' && $('#login-form-password').val() !== '') {
                    $('#login-button').removeClass('disabled');
                } else {
                    $('#login-button').addClass('disabled');
                }
            });

            $(modal.modalBox).find('.close-button').on('click', function (e) {
                if (isFromCart) {
                    $('body').trigger('cart:invalidatePersistentCustomerSession');
                }
                modal.close();
            });

            $('body').one('socialLoginError:standardCustomer, persistentLogin:standardCustomer', function (e) {
                modal.close();
                modal.destroy();
            });

            if (currentPage === 'Reviews-Show') {
                let triggerSocialRegistration = (e) => {
                    $('body').trigger('customer:socialRegistration', { socialName: $(e.currentTarget).attr('title') });
                };
                $('body').off('click', '.tingle-modal #loginLayerGigya table table table table button', triggerSocialRegistration);
                $('body').on('click', '.tingle-modal #loginLayerGigya table table table table button', triggerSocialRegistration);
            }
        });
    }
}

const header = new Header();
export default header;
